import React from "react";
import { FiMail, FiMapPin, FiPhone } from "react-icons/fi";
import { FaLinkedinIn, FaYoutube } from "react-icons/fa6";
import ContactFooterNewsletterCard from "./ContactFooterNewsletterCard";

const ITEM_ICONS = {
  phone: FiPhone,
  email: FiMail,
  office: FiMapPin,
};

const SOCIAL_ICONS = {
  linkedin: FaLinkedinIn,
  youtube: FaYoutube,
};

export default function ContactFooterInfoCard({
  items,
  followLabel,
  socialLinks,
  newsletter,
  responseTime,
}) {
  return (
    <div className="flex flex-col rounded-[1.6rem] border border-[rgba(255,255,255,0.05)] bg-[rgba(23,24,29,0.92)] p-[1.35rem] shadow-[inset_0_1px_0_rgba(255,255,255,0.02)] sm:p-[1.7rem]">
      <div className="grid gap-[1.15rem]">
        {items.map((item) => {
          const Icon = ITEM_ICONS[item.icon] ?? FiPhone;
          const content = (
            <>
              <span
                className="inline-flex h-[2.85rem] w-[2.85rem] items-center justify-center rounded-full bg-[rgba(255,255,255,0.055)] text-base text-[#c3cffd]"
                aria-hidden="true"
              >
                <Icon />
              </span>
              <div>
                <p className="m-0 text-[0.72rem] font-bold uppercase tracking-[0.16em] text-[rgba(255,255,255,0.52)]">
                  {item.label}
                </p>
                {item.lines.map((line) => (
                  <p key={line} className="mt-[0.3rem] text-base font-medium leading-[1.55] text-[#f6f8ff]">
                    {line}
                  </p>
                ))}
              </div>
            </>
          );

          return item.href ? (
            <a
              key={item.label}
              href={item.href}
              className="grid grid-cols-[3rem_1fr] items-start gap-[0.95rem] text-inherit no-underline"
            >
              {content}
            </a>
          ) : (
            <div key={item.label} className="grid grid-cols-[3rem_1fr] items-start gap-[0.95rem]">
              {content}
            </div>
          );
        })}
      </div>

      <div className="mt-[1.9rem]">
        <p className="mb-[0.8rem] text-[0.72rem] font-bold uppercase tracking-[0.16em] text-[rgba(255,255,255,0.56)]">
          {followLabel}
        </p>
        <div className="flex gap-[0.7rem]">
          {socialLinks.map((social) => {
            const Icon = SOCIAL_ICONS[social.icon] ?? FaLinkedinIn;

            return (
              <a
                key={social.label}
                href={social.href}
                className="inline-flex h-[2.55rem] w-[2.55rem] items-center justify-center rounded-full bg-[rgba(255,255,255,0.05)] text-[#edf2ff] no-underline transition duration-200 hover:-translate-y-px hover:bg-[rgba(112,136,255,0.22)]"
                aria-label={social.label}
                target="_blank"
                rel="noreferrer noopener"
              >
                <Icon />
              </a>
            );
          })}
        </div>
      </div>

      <ContactFooterNewsletterCard newsletter={newsletter} />

      {responseTime ? (
        <div className="mt-auto border-t border-[rgba(255,255,255,0.05)] pt-[1.6rem] text-[0.9rem] leading-[1.7] text-[rgba(220,226,236,0.66)]">
          {responseTime}
        </div>
      ) : null}
    </div>
  );
}
